import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { TornEdge } from './TornEdge';
import { Reveal } from './Reveal';
import { ActionLink } from './Buttons';
import { services } from '../data/services';
import { contact } from '../data/contact';
export function Services() {
  return <section id="servicios" aria-labelledby="servicios-title" className="relative bg-ink py-20 sm:py-28" data-id="element-170" data-mp="18ufwduxhjfsz">
      <TornEdge colorClassName="bg-ink" data-id="element-171" data-mp="13xpgb7lokk7k" />
      <div className="relative mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-172" data-mp="z43gwh4j2ctp">
        <Reveal data-id="element-173" data-mp="u5s540uo9s8u">
          <SectionHeading id="servicios-title" folio="Sección III · Catálogo de prácticas" title="Prácticas Espirituales Personalizadas" data-id="element-174" data-mp="u5a2mmhf2hsh" />
        </Reveal>

        <ul className="mt-14 grid gap-7 sm:grid-cols-2" data-id="element-175" data-mp="l5mz9v54n1ws">
          {services.map((service, index) => <Reveal as="li" key={service.id} delay={index * 0.08} data-id="element-176" data-mp="g7bo9h33ilcz" data-mpi={index}>
              <article className="group relative h-full bg-plum-deep/80 p-3 ring-1 ring-gold/30 transition-shadow duration-300 hover:shadow-lift" data-id="element-177" data-mp="36cpxw2ocktbx">
                {/* Clip metálico sujetando la ficha */}
                <span aria-hidden="true" className="absolute -top-3 left-8 z-10 h-7 w-4 rounded-sm border border-gold/70 bg-gold/25 shadow-lift" data-id="element-178" data-mp="2xc1f6uo0e4sp" />

                <div className="relative overflow-hidden" data-id="element-179" data-mp="3q0qd6ktrpu08">
                  <img src={service.image} alt={service.imageAlt} className="block aspect-[4/3] w-full object-cover grayscale transition-all duration-700 group-hover:scale-[1.04] group-hover:grayscale-0" loading="lazy" data-id="element-180" data-mp="3pychc9r9kdrm" />
                  <div aria-hidden="true" className="absolute inset-0 bg-plum/70 mix-blend-color transition-opacity duration-700 group-hover:opacity-0" data-id="element-181" data-mp="24n4010f3go46" />
                  <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-ink via-ink/25 to-transparent" data-id="element-182" data-mp="1pjujxgbc9ci5" />

                  {/* Tarjeta de índice sobreimpresa */}
                  <div className="absolute inset-x-3 bottom-3 border border-gold/50 bg-paper/95 px-4 py-3 shadow-lift" data-id="element-183" data-mp="1gqhghkfnesht">
                    <div className="flex items-start gap-3" data-id="element-184" data-mp="1bsfoub45pkuq">
                      <span aria-hidden="true" className="text-base leading-6" data-id="element-185" data-mp="16unw5evotuph">
                        {service.emoji}
                      </span>
                      <h3 className="font-display text-[0.92rem] font-semibold uppercase leading-snug tracking-[0.08em] text-ink sm:text-base" data-id="element-186" data-mp="11wuriqa198rb">
                        {service.title}
                      </h3>
                    </div>
                  </div>
                </div>

                <p className="px-4 pb-5 pt-6 text-sm leading-relaxed text-body sm:text-[0.95rem]" data-id="element-187" data-mp="2s6648e0q7vjo">
                  {service.description}
                </p>
              </article>
            </Reveal>)}
        </ul>

        <Reveal className="mt-12 flex justify-center" data-id="element-188" data-mp="2zqgqmh9t6qt3">
          <ActionLink href={contact.whatsappHref} variant="gold" target="_blank" rel="noreferrer" className="w-full sm:w-auto" data-id="element-189" data-mp="2zp5lad0ptazv">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-190" data-mp="39eyp2rum8ltk" />
            Consultar por WhatsApp
          </ActionLink>
        </Reveal>
      </div>
    </section>;
}